export const scheduledInterviewStatusId = 1;
export const completedInterviewStatusId = 2;
export const cancelledInterviewStatusId = 3;
export const INTERVIEW_STATUS_COLORS = {
  [scheduledInterviewStatusId]: 'red',
  [completedInterviewStatusId]: 'green',
  [cancelledInterviewStatusId]: 'gray',
};
